import {Dispatch, SetStateAction, useState} from 'react';
import {useSelector} from 'react-redux';

import {portIncidentAPI} from 'features/port/api/portIncidentAPI';
import IPagination from 'shared/api/model/IPagination';
import {userSelector} from 'entities/user';

import IPortIncident from './PortIncident/IPortIncident';

export interface IUsePortMonitorIncidents {
    pagination: IPagination<IPortIncident> | undefined,
    isLoading: boolean,
    isEmptyList: boolean,
    timezone: string | null | undefined,
    setPage: Dispatch<SetStateAction<number>>,
}

export const usePortMonitorIncidents = (portMonitorId: string): IUsePortMonitorIncidents => {
    const [page, setPage] = useState(1);

    const user = useSelector(userSelector);

    const {data: pagination, isLoading} = portIncidentAPI.useGetPortIncidentsQuery({
        page,
        filters: [`portMonitor.uuid=${portMonitorId}`],
    });

    return {
        pagination,
        isLoading,
        isEmptyList: !isLoading && (pagination?.items ?? []).length === 0,
        timezone: user?.timezone,
        setPage,
    };
};

export default usePortMonitorIncidents;
